export default function titleCase(str: string) {
    return str && str.split(" ").map((w) => w.slice(0, 1).toUpperCase().concat(w.slice(1))).join(" ")
}
